import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';

import InfoFI from './InfoFI';
import InfoEN from './InfoEN';
import InfoSV from './InfoSV';
import printElem from 'lib/printElement';
import { getLatestCommitData } from 'lib/documentHandling';

// Get score sums from document questions
export const getSum = (qArray, document) => {
  let sum = 0;

  qArray.forEach(q => {
    sum = sum + path(['content', 'question' + q], document) || 0;
  });
  // console.log(sum);
  return sum;
};

const MSNQInfoText = ({ document, statusDoc = {}, intl: { locale, formatMessage } }) => {
  const totalScore = path(['score'], document) || 0;
  const statusFatigue =
    path(['commits', 'length'], statusDoc) > 0
      ? path(['sections', 'narcomsFatigue'], getLatestCommitData(statusDoc))
      : 0;
  const statusMood =
    path(['commits', 'length'], statusDoc) > 0
      ? path(['sections', 'narcomsDepression'], getLatestCommitData(statusDoc))
      : 0;

  return (
    <div id="msnqInfoArea">
      {locale === 'en' ? (
        <InfoEN totalScore={totalScore} statusMood={statusMood} statusFatigue={statusFatigue} document={document} />
      ) : locale === 'sv' ? (
        <InfoSV totalScore={totalScore} statusMood={statusMood} statusFatigue={statusFatigue} document={document} />
      ) : (
        <InfoFI totalScore={totalScore} statusMood={statusMood} statusFatigue={statusFatigue} document={document} />
      )}
      <a href="#" onClick={() => printElem('msnqInfoArea', 'MyMS - MSNQ')}>
        {formatMessage({ id: 'dictionary.print' })}
      </a>
    </div>
  );
};

MSNQInfoText.propTypes = {
  document: PropTypes.object,
  statusDoc: PropTypes.object,
  intl: intlShape
};

export default injectIntl(MSNQInfoText);
